import { render } from "./OrderHistoryRating.vue?vue&type=template&id=f4e87e86"
import script from "./OrderHistoryRating.vue?vue&type=script&lang=js"
export * from "./OrderHistoryRating.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__